import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  overflow: hidden;
  text-align: center;

  > img {
    width: 60px;
    height: 60px;
  }
  > h2 {
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    max-width: 220px;
  }
`;

export const AnimatedDots = styled.span`
  display: inline-block;
  width: 8px;
  text-align: left;
  &::after {
    content: '';
    display: inline-block;
    width: 8px;
    text-align: left;
    animation: dots 2s steps(3, end) infinite;
  }
  @keyframes dots {
    0% {
      content: '';
    }
    33% {
      content: '.';
    }
    66% {
      content: '..';
    }
    100% {
      content: '...';
    }
  }
`;
